/*
 * 软件客户端
 */
import React from 'react';
import Specialty from 'components/product/specialty';
import Contact from 'components/contact';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import UseResize from 'utils/hooks/useResize';
import cn from 'classnames';
import style from './index.module.scss';

const IMG_PREFIX = 'https://sdk-source.xylink.com/website/assets/client/';
const features = [
  {
    title: '一键组会，一秒入会',
    desc: '快速创建会议号，支持App消息、微信、短信、邮件全网渠\n道通知，简单极速入会',
    mDesc: '快速创建会议号，支持App消息、微信、短\n信、邮件全网渠道通知，简单极速入会',
  },
  {
    title: '预约会议，高效有序',
    desc: '支持预约周期会议，实时了解当前会议状态，让会议开启更有序',
    mDesc: '支持预约周期会议，实时了解当前会议状态，\n让会议开启更有序',
  },
  {
    title: '单位通讯录，全员覆盖',
    desc: '自主创建单位/企业，可邀请同事加入通讯录，支持分级分权',
  },
  {
    title: '小程序入会，轻便接入',
    desc: '支持通过小程序快速接入，会议开展更灵活',
  },
];
const functions = [
  { title: '高清体验，稳定流畅', desc: '全高清画质不花屏，畅享面对面交流效果\n声音高度还原，会议过程流畅不卡顿', img: '' },
  { title: '会议主持，专业易用', desc: '自定义显示布局，可进行点名、发送字幕、\n会议锁定、审批入会，会议更有序', img: '' },
  { title: '便捷共享，交互批注', desc: '一键共享，同步显示各类文档、图片、应用界面\n交互式批注可存档，内容水印更安全', img: '' },
  { title: '会议拆分，分组讨论', desc: '支持大会随时拆小会、小会一键合并大会\n方便发起分组讨论，提升沟通效果', img: '' },
  { title: '丰富应用，创新业务', desc: '智能美颜、虚拟背景、电子铭牌、会议纪要、\n同声传译、签到/答题/投票/即时消息', img: '' },
];
const scenes = [
  { title: '活动直播，实时互动', desc: '支持高清直播，一键对外分享\n具有直播公告、实时互动、发起投票等功能', img: '' },
  { title: '视频录制，随心剪辑', desc: '高清录制，支持自动或自定义布局\n在线视频剪辑，一键分享，范围可控', img: '' },
];
const Client = () => {
  const size = UseResize();
  return (
    <Wrapper title="软件客户端" pageKey="productClient" current={1} customClass={style.client}>
      <MultipleBanner
        mUrl={'m/bg0.jpg'}
        pcUrl={'bg-img0.jpg'}
        title={'软件客户端'}
        desc={'覆盖全应用场景，结合智能硬件终端，高效构建“端云一体”的高品质视频会议\n电脑、平板、手机、小程序、网页端等全适配，纵享丰富音视频应用'}
        mDesc={'覆盖全应用场景，结合智能硬件终端，高效构建\n“端云一体”的高品质视频会议\n电脑、平板、手机、小程序、网页端等全适配，\n纵享丰富音视频应用'}
        imageHost={IMG_PREFIX}
        className={style.firstBanner}
      />
      <div className={style.features}>
        <div className={style.header}>
          <div className={style.bigTitle}>秒级组会，一键开启高效会议</div>
          {<img className={style.arrowImg} src={`${IMG_PREFIX}arrow-img0.png`} alt="arrowImg" />}
        </div>
        <div className={style.content}>
          {features.map((item, index: number) => {
            return (
              <div className={style.feature} key={index}>
                <div className={style.title}>{item.title}</div>
                <div className={style.desc} dangerouslySetInnerHTML={{ __html: `${size.width < 768 ? item.mDesc ?? item.desc : item.desc}`.replace(/\n/g, '<br/>') }}></div>
                <img className={style.arrowImg} src={`${IMG_PREFIX}arrow-img1.png`} alt="arrowImg" />
                <img className={style.bgImg} src={`${IMG_PREFIX}feature-img${index}.png`} alt="" />
              </div>
            );
          })}
        </div>
      </div>
      <div className={style.functions}>
        <div className={style.header}>
          <div className={style.bigTitle}>丰富功能，体验高品质会议</div>
          <img className={style.arrowImg} src={`${IMG_PREFIX}arrow-img0.png`} alt="arrowImg" />
        </div>
        {functions.map((item, idx: number) => {
          return (
            <div className={style.function} key={idx}>
              <Specialty
                title={item.title}
                desc={item.desc}
                image={`${IMG_PREFIX}function-img${idx}.png`}
                type={idx % 2 !== 0 ? 2 : 1}
                imgClass={cn(style.img, idx === functions.length - 1 && style.lastImg)}
                descClass={style.desc}
              />
            </div>
          );
        })}
        <img className={style.bigArrow0} src={`${IMG_PREFIX}bigArrow0.png`} alt="" />
        <img className={style.bigArrow1} src={`${IMG_PREFIX}bigArrow1.png`} alt="" />
      </div>
      <div className={style.scenes}>
        <div className={style.header}>
          <div className={style.bigTitle}>随心分享，全面满足业务需求</div>
          {<img className={style.arrowImg} src={`${IMG_PREFIX}arrow-img2.png`} alt="arrowImg" />}
        </div>
        {scenes.map((item, idx: number) => {
          return (
            <div className={style.scene} key={idx}>
              <Specialty
                title={item.title}
                desc={item.desc}
                image={`${IMG_PREFIX}share-img${idx}.png`}
                type={idx % 2 !== 0 ? 1 : 2}
                titleClass={style.title}
                descClass={style.desc}
                imgClass={style.img}
              />
            </div>
          );
        })}
      </div>
      <div className={style.lastBanner} style={{ backgroundImage: `url(${size.width < 768 ? `${IMG_PREFIX}m/bg1.jpg` : `${IMG_PREFIX}bg-img1.jpg`})` }}>
        <div className={style.header}>
          <div className={style.bigTitle}>适配信创，安全护航线上会议</div>
          {<img className={style.arrowImg} src={`${IMG_PREFIX}arrow-img2.png`} alt="arrowImg" />}
        </div>
        <Specialty
          title={'小鱼易连信创云视频客户端'}
          desc={'基于国产化平台打造，适配国产化CPU处理器操作系统的终端\n具备卓越的音视频效果，拥有丰富的会议协作能力\n全面保障线上会议和云端协同安全流畅'}
          mDesc={'基于国产化平台打造\n适配国产化CPU处理器/操作系统的终端\n具备卓越的音视频效果，拥有丰富的会议协作能力\n全面保障线上会议和云端协同安全流畅'}
          image={`${IMG_PREFIX}img.png`}
          textClass={style.text}
          titleClass={style.title}
          descClass={style.desc}
          imgClass={style.img}
        />
        <Contact className={style.contact} btnType={'newBtn'} />
      </div>
    </Wrapper>
  );
};

export default Client;
